import { Component, computed, inject, input, OnInit, output, signal } from '@angular/core';

import { Option } from '@eiq/ui';

import { Source, SourceVariables } from '@empathy/survey/base';

import { SourceVariablePreview } from '../../../models/sources/source-variable-preview.model';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-preview-variables-form',
  templateUrl: 'preview-variables-form.component.html',
  styleUrls: ['./preview-variables-form.component.scss']
})
export class PreviewVariablesFormComponent implements OnInit {
  disabled$ = input(false, { alias: 'disabled' });

  apply = output<SourceVariables>();

  allowApply$ = computed(() => this.filteredSourceVariables$().some((sv) => sv.value().length > 0));
  filteredSourceVariables$ = computed(() => {
    const source = this.selectedSource$();
    if (!source) {
      return [];
    }

    return source.variables.map(
      (variable) =>
        new SourceVariablePreview(
          source.id,
          variable.variableToken,
          variable.options?.length > 0 ? variable.options.map((o) => ({ value: o.value, text: o.value })) : []
        )
    );
  });
  selectedSource$ = signal<Source>(null);
  sources$ = signal<Option<Source>[]>([]);

  private surveyEditorService = inject(SurveyEditorService);

  ngOnInit(): void {
    this.sources$.set(this.mapSourceOptions());
  }

  onApply(): void {
    if (this.disabled$()) {
      return;
    }

    const vf: SourceVariables = {};
    this.filteredSourceVariables$()
      .filter((sv) => sv.value() !== '')
      .forEach((sv) => (vf[sv.token] = sv.value()));

    this.apply.emit(vf);
  }

  onReset(): void {
    if (!this.disabled$()) {
      this.apply.emit({});
    }
  }

  private mapSourceOptions(): Option<Source>[] {
    const sources = this.surveyEditorService.surveyEditor$().sources.map();

    return !sources
      ? []
      : sources.filter((s) => s.variables.length > 0).map((source) => ({ value: source, text: `${source.id}.${source.title}` }) as Option<Source>);
  }
}
